import React from 'react';
import config from 'cfg';
import cx from 'classnames';
import UI from '../UI';
import ThemeColorsPreview from '../core/ThemeColorsPreview';
import WidgetShowCase from '../core/WidgetShowCase';

import WDPContext from 'WDPContext';

var data = {
    eventLive: {
        _id: '57ae735cca3c1dff73d94ab7',
        eventId: 2349244,
        startDate: '2016-12-07T15:30:00.000Z',
        statusType: 'inprogress',
        statusFull: '1st half',
        homeId: 584106,
        awayId: 474523,
        homeName: 'Racing Roma',
        awayName: 'Tuttocuoio',
        homeShortName: 'CTR',
        awayShortName: 'TUT',
        countryId: 4,
        country: 'Italien',
        tournamentName: 'Italien Serie C1 A',
        tournamentStageId: 845999,
        tournamentYear: '2016/2017',
        tournamentId: 10776,
        tournamentTemplateId: 147,
        sportId: 1,
        sport: 'football',
        teams: [584106, 474523],
        version: 31,
        score: { home: '1', away: '0' },
        detailedScore: { runningscore: { home: '1', away: '0' }, ordinarytime: { home: '1', away: '0' } },
        homeIsToBeDecided: false,
        awayIsToBeDecided: false,
        properties: { round: '17', live: 'yes', gameStarted: '2016-12-07T15:30:51.000Z' },
        homeCountryId: 4,
        awayCountryId: 4
    },
    eventFinished: null,
    eventFinishedET: null,
    eventFinishedPenalty: null,
    eventUpcoming: {
        _id: '57bf969b8946a8c3793f248c',
        eventId: 2363765,
        startDate: '2016-12-07T19:45:00.000Z',
        statusType: 'notstarted',
        statusFull: 'Not started',
        homeId: 8633,
        awayId: 9789,
        homeName: 'Real Madrid',
        awayName: 'Borussia Dortmund',
        homeShortName: 'REA',
        awayShortName: 'DOR',
        countryId: 11,
        country: 'International',
        tournamentName: 'Champions League',
        tournamentStageId: 846094,
        tournamentYear: '2016/2017',
        tournamentId: 10436,
        tournamentTemplateId: 42,
        sportId: 1,
        sport: 'football',
        teams: [8633, 9789],
        version: 25,
        incidents: [],
        betOffers: [
            {
                type: '1x2',
                scope: 'ord',
                odd1: 1.85,
                oddX: 4,
                odd2: 4.2,
                live: false,
                providerId: 23
            },
            { type: '1x2', scope: 'ord', odd1: 1.87, oddX: 3.75, odd2: 3.9, live: false, providerId: 144 }
        ],
        score: { away: '0', home: '0' },
        detailedScore: { runningscore: { home: '0', away: '0' }, ordinarytime: { home: '0', away: '0' } },
        homeIsToBeDecided: false,
        awayIsToBeDecided: false,
        properties: {
            round: '6',
            live: 'yes',
            liveStatsType: 'livestats',
            venueName: 'Estadio Santiago Bernabeu',
            refereeFK: '298894',
            hasLineup: true,
            hasLineupSent: true
        },
        homeCountryId: 8,
        awayCountryId: 3
    },
    eventWith2RedCards: {
        _id: '57bf96968946a8c3793f2419',
        eventId: 2363692,
        startDate: '2016-12-06T19:45:00.000Z',
        statusType: 'finished',
        statusFull: 'Finished',
        homeId: 8688,
        awayId: 10188,
        homeName: 'Dynamo Kiev',
        awayName: 'Besiktas',
        homeShortName: 'DYN',
        awayShortName: 'BES',
        countryId: 11,
        country: 'International',
        tournamentName: 'Champions League',
        tournamentStageId: 846090,
        tournamentYear: '2016/2017',
        tournamentId: 10436,
        tournamentTemplateId: 42,
        sportId: 1,
        sport: 'football',
        teams: [8688, 10188],
        version: 109,

        score: { home: '6', away: '0' },
        detailedScore: {
            finalresult: { home: '6', away: '0' },
            halftime: { home: '4', away: '0' },
            runningscore: { home: '6', away: '0' },
            ordinarytime: { home: '6', away: '0' }
        },
        homeIsToBeDecided: false,
        awayIsToBeDecided: false,
        properties: {
            round: '6',
            live: 'yes',
            venueName: 'Stadion NSK Olimpiyskiy, Kyiv',
            liveStatsType: 'livestats',
            refereeFK: '155022',
            hasLineup: true,
            hasLineupSent: true,
            lineupConfirmed: 'yes',
            lineupConfirmedSent: true,
            gameStarted: '2016-12-06T19:47:35.000Z',
            firstHalfEnded: '2016-12-06T20:35:45.000Z',
            secondHalfStarted: '2016-12-06T20:52:30.000Z',
            spectators: '14036',
            secondHalfEnded: '2016-12-06T21:37:36.000Z',
            gameEnded: '2016-12-06T21:37:36.000Z',
            verified: 'yes'
        },
        homeCountryId: 53,
        awayCountryId: 13
    }
};

class ThemePreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    renderColorPreview(name, clazz) {
        return (
            <div className={cx('bg-' + clazz, 'color-preview')}>
                <span>{name}</span>
            </div>
        );
    }

    render() {
        let { theme, sectionsToShow, editVariable } = this.props;
        let themeClass = 'wdp_' + (theme || 'default');
        let wdp = 'wdp';

        return (
            <WDPContext {...this.props} key={sectionsToShow.toString()}>
                <div className="theme-preview">

                    <div className="widget-container">
                        <WidgetShowCase editVariable={editVariable} />
                    </div>

                    {sectionsToShow.indexOf('Typography') != -1 &&
                        <section className={cx(wdp, themeClass)}>
                            <div className="wdp-widget">
                                <UI.WidgetHeader title="TYPOGRAPHY" />
                                <p>Paragraph $font-size-base</p>
                                <h1>h1. Heading <small>Secondary text</small></h1>
                                <h2>h2. Heading <small>Secondary text</small></h2>
                                <h3>h3. Heading <small>Secondary text</small></h3>
                                <h4>h4. Heading <small>Secondary text</small></h4>
                                <h5>h5. Heading <small>Secondary text</small></h5>
                                <h6>h6. Heading <small>Secondary text</small></h6>
                            </div>
                        </section>}

                    {sectionsToShow.indexOf('Buttons') != -1 &&
                        <section className={cx(wdp, themeClass)}>
                            <div className="wdp-widget">
                                <div classNames="wdp-content">
                                    <UI.WidgetHeader title="BUTTONS" />
                                    <p>Button variants</p>
                                    <button className="wdp-btn wdp-btn-default">Default action</button> {UI.nbsp}
                                    <button className="wdp-btn wdp-btn-primary">Primary action</button> {UI.nbsp}
                                    <button className="wdp-btn wdp-btn-neutral">Neural action</button> {UI.nbsp}
                                    <button className="wdp-btn wdp-btn-success">Success action</button> {UI.nbsp}
                                    <button className="wdp-btn wdp-btn-alert">Alert action</button> {UI.nbsp}
                                    <p>Button sizes</p>
                                    <button className="wdp-btn wdp-btn-lg">Button lg</button> {UI.nbsp}
                                    <button className="wdp-btn">Button</button> {UI.nbsp}
                                    <button className="wdp-btn wdp-btn-sm">Button sm</button> {UI.nbsp}
                                    <button className="wdp-btn wdp-btn-xs">Button xs</button> {UI.nbsp}
                                </div>
                            </div>
                        </section>}

                    {sectionsToShow.indexOf('Dividers') != -1 &&
                        <section className={cx(wdp, themeClass)}>
                            <div className="wdp-widget">
                                <UI.WidgetHeader title="TABLES" />
                                <table className="wdp-table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>First Name</th>
                                            <th>Last Name</th>
                                            <th>Username</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th scope="row">1</th>
                                            <td>Mark</td>
                                            <td>Otto</td>
                                            <td>@mdo</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">2</th>
                                            <td>Jacob</td>
                                            <td>Thornton</td>
                                            <td>@fat</td>
                                        </tr>
                                        <tr>
                                            <th scope="row">3</th>
                                            <td>Larry</td>
                                            <td>the Bird</td>
                                            <td>@twitter</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>}

                </div>
            </WDPContext>
        );
    }
}

export default ThemePreview;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/common/ThemePreview.js
 **/